<div class="app-container">
    <app-topbar></app-topbar>
    <app-sidebar 
      [isExpanded]="isExpanded" 
      (toggleSidebar)="isExpanded = !isExpanded">
    </app-sidebar>
  
    <main [style.margin-left]="isExpanded ? '260px' : '70px'" style="transition: 0.3s">
      <router-outlet></router-outlet>
    </main>
</div>